// extracted by mini-css-extract-plugin
export default {"p_tye":"d13e2ac336","slcted":"_787af9f2bc","slc_color":"_526f9390f2","item_p":"_8ae969a250","r0":"_838c3c980d"};